import { useMemo } from "react";
import { getRequiredFields } from "components/form/utils";
import { applicantSchema } from "./schema";;
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCreateOpeningApplicant } from "../create/mutation";
import { useUpdateOpeningApplicant } from "../update/mutation";
import { fetchOpeningApplicantDataforForm } from "./read";

export const useOpeningApplicantForm = ({ applicantId, openingId }) => {
    const navigate = useNavigate();

    const createOpeningApplicantMutation = useCreateOpeningApplicant();
    const updateOpeningApplicantMutation = useUpdateOpeningApplicant();

    const form = useForm({
        resolver: zodResolver(applicantSchema),
        defaultValues: {
            opening: openingId,
            employee: "",
            experience: "",
            description: "",
            resume_url: "",
            is_selected: undefined,
        },
    });

    const requiredFields = useMemo(
        () => getRequiredFields(applicantSchema),
        [applicantSchema],
    );

    async function handleCreate(context) {
        const values = context.values;
        const response = await createOpeningApplicantMutation.mutateAsync({
            values,
        });
        navigate(`/apps/openings/${openingId}/applicants/${response.id}`);
    }

    async function handleRead(id) {
        const response = await fetchOpeningApplicantDataforForm({ id });
        return {
            opening: openingId,
            ...response,
        };
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        const response = await updateOpeningApplicantMutation.mutateAsync({
            applicantId: id,
            values,
        });
        navigate(-1);
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    };
};
